import { SectionHeader, BfiCustomStore } from '../../common/SharedComponents';
import store, { searchActions } from '@apply/adminStore';
import debounce from 'lodash.debounce';
import IncompleteAppsTable from './tables/IncompleteAppsTable';
import IncompleteReviewModal from './modals/IncompleteReviewModal';
import AuditHistoryModal from '../common/modals/AuditHistoryModal';
import DeclineOrRecycleModal from '../common/modals/DeclineOrRecycleModal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { useSelector } from 'react-redux';

function IncompleteAppsLanding() {
    const searchState = useSelector((state) => state.searchState);
    const { dispatch } = store;
    const debouncedSearch = debounce(dispatch, 500);

    const incompleteAppsGridStore = new BfiCustomStore();

    const _onSearchChange = (event) => {
        debouncedSearch(
            searchActions.setSearchText({
                searchText: {
                    ...searchState.searchText,
                    incompleteApplications: event.target.value,
                },
            })
        );
    };

    return (
        <>
            <SectionHeader title='Incomplete Applications' />
            <div
                className='main-content'
                style={{ padding: 0, backgroundColor: '#f4f4f4' }}
            >
                <div className='input-has-icon main-search'>
                    <input
                        type='search'
                        placeholder='Search on Borrower Name, Entity or Email...'
                        defaultValue={searchState?.searchText?.application}
                        onChange={_onSearchChange}
                    />
                    <FontAwesomeIcon
                        icon={faSearch}
                        aria-hidden='true'
                        className='icon'
                    />
                </div>
                <div
                    className='scrollable-content'
                    style={{ padding: '1rem' }}
                >
                    <div
                        className='applications accordion'
                        data-accordion=''
                        data-allow-all-closed='true'
                        data-multi-expand='true'
                    >
                        <IncompleteAppsTable gridStore={incompleteAppsGridStore} />
                    </div>
                </div>
            </div>
            <IncompleteReviewModal />
            <AuditHistoryModal />
            <DeclineOrRecycleModal />
        </>
    );
}

export default IncompleteAppsLanding;
